import { render, staticRenderFns } from "./ExcTabs.vue?vue&type=template&id=1baa608d&scoped=true&"
import script from "./ExcTabs.vue?vue&type=script&lang=ts&"
export * from "./ExcTabs.vue?vue&type=script&lang=ts&"
import style0 from "./ExcTabs.vue?vue&type=style&index=0&id=1baa608d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baa608d",
  null
  
)

export default component.exports